import { Fab, Zoom } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'

const fabStyle = {
  position: 'fixed',
  bottom: 72,
  right: 16,
}

const FloatingActionButton = ({ in: enabled, label, color, icon, variant, ...rest }) => {
  const theme = useTheme()

  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen,
  }

  return (
    <Zoom
      in={enabled}
      timeout={transitionDuration}
      style={{
        transitionDelay: `${transitionDuration.exit}ms`,
      }}
      unmountOnExit
    >
      <Fab sx={fabStyle} variant={variant} aria-label={label} color={color} {...rest}>
        {icon}
        {variant === 'extended' && label}
      </Fab>
    </Zoom>
  )
}

export default FloatingActionButton
